import type { FC } from "react"
import { AppLoadingContainer } from "./AppLoading.styles"
import Loading from "public/images/Loading.gif"
import Image from "next/image"

interface AppLoadingProps {
  isLoading: boolean
}

const AppLoading: FC<AppLoadingProps> = ({ isLoading = false}) => {
  return (
    isLoading && (
      <AppLoadingContainer>
        <Image alt='loading' src={Loading} width={250} height={250} />
      </AppLoadingContainer>
    )
  )
}

export default AppLoading
